import { z } from "zod";

import { ExtractAtomicOperationFromDefinition } from "../../../atomic-operations/index.js";
import { DateTimeString, zDateTimeString } from "../../../dateTypes.js";
import { SecondaryCalculations } from "../../../dbt/generated/dbtSecondaryCalculations.js";
import { DataConnectionId, DbtMetricCellId } from "../../../idTypeBrands.js";
import { makeUpdateCellContentsOperation } from "../makeUpdateCellContentsOperation.js";
import { zDataConnectionId } from "../../../zod/ZodIdTypeBrands.js";

export interface DbtMetricCellUpdatableFields {
  /**
   * perms on this are manually checked server side
   */
  connectionId: DataConnectionId | null;
  resultVariable: string;
  useRichDisplay: boolean;
  castDecimals: boolean;
  selectedTimegrain: string | null;
  selectedDimensions: string[] | null;
  startDate: DateTimeString | null;
  endDate: DateTimeString | null;
  secondaryCalculations: SecondaryCalculations[];
  useNativeDates: boolean;
}

const _UpdateDbtMetricCellSafeFields: {
  [key in keyof DbtMetricCellUpdatableFields]: "";
} = {
  connectionId: "",
  resultVariable: "",
  useRichDisplay: "",
  castDecimals: "",
  selectedTimegrain: "",
  selectedDimensions: "",
  startDate: "",
  endDate: "",
  secondaryCalculations: "",
  useNativeDates: "",
};
export const UpdateDbtMetricCellSafeFields = Object.keys(
  _UpdateDbtMetricCellSafeFields,
);

export const UPDATE_DBT_METRIC_CELL = makeUpdateCellContentsOperation<
  DbtMetricCellUpdatableFields,
  DbtMetricCellId
>()({
  type: "UPDATE_DBT_METRIC_CELL",
  fields: {
    connectionId: zDataConnectionId.nullable(),
    resultVariable: z.string(),
    useRichDisplay: z.boolean(),
    castDecimals: z.boolean(),
    selectedTimegrain: z.string().nullable(),
    selectedDimensions: z.array(z.string()).nullable(),
    startDate: zDateTimeString.nullable(),
    endDate: zDateTimeString.nullable(),
    // Generated dbt config shapes with no runtype to bridge; validated as objects.
    secondaryCalculations: z.array(z.record(z.string(), z.unknown())),
    useNativeDates: z.boolean(),
  },
  entityName: "DbtMetricCell",
  fieldName: "dbtMetricCellId",
});
export type UPDATE_DBT_METRIC_CELL = ExtractAtomicOperationFromDefinition<
  typeof UPDATE_DBT_METRIC_CELL
>;
